import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import CategoryGrid from "./components/CategoryGrid";
import ArticleCTASection from "./components/ArticleCTASection";
import TestimonialSection from "./components/TestimonialSection";
import SEOTextSection from "./components/SEOTextSection";
import JsonLd from "@/components/base/JsonLd";
import { siteConfig } from "@/mocks/categories";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "GTBuy Spreadsheet",
    url: siteConfig.siteUrl,
    description:
      "The fastest product comparison system for smarter shopping decisions. Compare prices, find the best deals, and shop with confidence.",
    potentialAction: {
      "@type": "SearchAction",
      target: `${siteConfig.siteUrl}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "GTBuy Spreadsheet — Smart Product Comparison & Shopping Tool",
    url: siteConfig.siteUrl,
    description:
      "Discover GTBuy Spreadsheet — the fastest product comparison system for smarter shopping decisions. Compare prices, find the best deals, and shop with confidence using our intuitive spreadsheet tool.",
    isPartOf: {
      "@type": "WebSite",
      name: "GTBuy Spreadsheet",
      url: siteConfig.siteUrl,
    },
    about: {
      "@type": "Thing",
      name: "Product Comparison Spreadsheet",
      description:
        "An intelligent spreadsheet-based product comparison tool that helps shoppers compare prices, features, and deals across multiple product categories including Shoes, Hoodies, T-Shirts, Jackets, Pants, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and other items.",
    },
  },
];

export default function Home() {
  return (
    <>
      <JsonLd data={homeJsonLd as unknown as Record<string, unknown>} />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <AboutSection />
          <CategoryGrid />
          <ArticleCTASection />
          <TestimonialSection />
          <SEOTextSection />
        </article>
      </main>
      <Footer />
    </>
  );
}